/**
 * FirmaTalepStandDetailPage.jsx — Firma Tarafı Stand Talepleri Detayı
 * Route: /Firma/Talepler/:standId
 *
 * FirmaStandDetailPage.jsx'in (Proje Bilgiler/Proje Dosyaları/İnşa İzni ve
 * Taahhütnameler) talep-dışı sekmelerinden ayrılmış, sadece taleplere adanmış kardeş
 * sayfa — FirmaTaleplerListPage'in ("Talepler Listesi") satır aksiyonu buraya
 * yönlendirir. 2026-07-15 revizyonu (/fromImageToLayout): eskiden 3 sekme
 * (Talepler / Teknik Talepler / Talepler Borç Durumu) vardı, "Talepler" 8
 * kategoriyi birden taşıyordu ve "Teknik Talepler" adının aksine iş izinleri
 * gösteriyordu. Artık standTalepService.js'teki düzeltilmiş sınıflandırmayla
 * eşleşen 5 sekme var: Teknik Talepler / Hizmet Talepleri / İş İzin Talepleri /
 * Ekipman Talepleri / Talepler Borç Durumu.
 *
 * 2026-07-23 revizyonu: Talepler Listesi'ndeki ikon-kare kutucuklar artık
 * `?tab=<TABS anahtarı>&kategori=<categoryKey>` ile buraya yönlendiriyor —
 * açılış sekmesi query param'dan seçilir, ilgili kategori araç çubuğu satırına
 * scrollIntoView + kısa süreli kenarlık vurgusu uygulanır (bkz. focusKategori).
 *
 * 2026-07-23 revizyonu (talep oluşturma popup'ı): Hizmet/İş İzin/Ekipman
 * Talepleri artık gerçekten oluşturulabiliyor — Teknik Talepler'in "+" düğmesi
 * hâlâ stub (o belge yükleme + kroki çıkış noktasıyla ayrı, kapsam dışı bir akış).
 * Diğer üçü ortak bir TalepOlusturModal kullanıyor: İş Türü (tıklanan kategoriden
 * otomatik dolar), Başlangıç/Bitiş, Sergilenecek Ürün, Yapılacak İş, Operatör,
 * görevli personel belgeleri (dosya yükleme), Kullanılacak Ekipman ve Malzeme
 * Listesi, Yapılacak İşin Kısa Özeti, Riskler ve Önlemler. Hizmet/İş İzin
 * panellerinde artık genel bir "+" düğmesi yok — İş Türü'nün "tıklanan şeyden"
 * otomatik dolması için giriş noktası doğrudan CategoryToolbar/IsIzinToolbar'daki
 * (henüz talep edilmemiş) kategori karesi oldu; Ekipman'da tek kategori olduğundan
 * mevcut "+" düğmesi bu akışa yönlendirildi. Oluşturma standTalepService.js'teki
 * createHizmetTalebi/createIsIzinTalebi/createEkipmanTalebi'yi çağırır, panel
 * kendi `refreshToken` prop'u üzerinden yeniden fetch eder.
 *
 * 2026-08-13 revizyonu: TalepOlusturModal'daki KVKK Onamı checkbox'ı (+ tıklayınca
 * açılan Lorem Ipsum metni) kaldırıldı — talep oluşturmak için gerekli değilmiş.
 * Zorunlu tek alanlar Başlangıç/Bitiş (bkz. canSubmit) — Label'larına kırmızı "*"
 * eklendi, formun geri kalanı (Sergilenecek Ürün/Yapılacak İş/Operatör/belgeler/vb.)
 * hep opsiyoneldi.
 *
 * 2026-08-10 revizyonu (mock→backend reconciliation): standId URL param'ı sayısalsa
 * (StandOverviewDetailPage.jsx'teki isNumericStandId deseni, dosya-yerel kopya —
 * bkz. util/knowledgebase/local-backend-testing.md) getStandOverviewDetail ve
 * standTalepService'in teknik/hizmet/isIzin/borç GET'leri forceLive:true ile
 * çağrılır; panellere prop olarak geçirilir. Hizmet/İş İzni oluşturma
 * (TalepOlusturModal) de aynı sinyali `target.forceLive` üzerinden taşır.
 *
 * 2026-08-11 revizyonu (Teknik Talepler → switch): eski ikon-kare + modal akışı
 * (kategoriye tıkla → Teknik Talep Planı belgesini yükle → talep tamamlanır, bkz.
 * eski TeknikTalepModal) kaldırıldı — FirmaProjelerListPage.jsx'teki Proje Beyanı
 * popup'ıyla aynı switch deseni geldi (bkz. TeknikTaleplerPanel'in kendi başındaki
 * not). Switch/kW artık declareTeknikTalepler üzerinden CANLI backend'e yazıyor —
 * bu uç zaten reconcile edilmiş, belge yükleme şartı da kalkınca fuar 298'deki
 * proje dosyası zero-date bug'ı (project-stand-listesi-reconciliation memory notu)
 * bu akışı artık etkilemiyor. Çıkış noktası (kroki) ise Deniz'in talimatıyla
 * KASITLI OLARAK mock/istemci-taraflı kalmaya devam ediyor — backend'de hâlâ
 * `cikis-noktasi` ucu yok (guide "Asked for but not built #1"). Test verisi:
 * fuar 298, decoratorFirmaId 49858 — stand 57552 dolu, 57553/57554/57555(t) sıfır
 * durumda, 57556/57557 kısmi (bkz. FE-StandTalepRequestController-guide.md).
 *
 * 2026-08-29 revizyonu (çıkış noktası → plan karşılaştırması): pin tek başına
 * 120 px'lik bir kroki değil; her kalem için SOLDA dekoratörün yüklediği Teknik
 * Talep Planı (standFileId 3, projectService köprüsünden okunur), SAĞDA kroki.
 * ⚠️ Plan yüklenmemişse pinleme KAPALI — işaret o çizimle karşılaştırılarak
 * okunuyor, çizim yoksa nokta tahminden ibaret. Aynı bileşen
 * (Components/Projects/CikisNoktasiPinner.jsx) Proje Beyanı sihirbazının "Çıkış
 * Noktaları" adımında da kullanılıyor — iki giriş noktası, tek kural.
 *
 * 2026-09-04 revizyonu (yerleşim): Teknik Talepler artık 2x2 yarım sayfa kutusu
 * (üstte iki, altta iki) ve "plan | kroki" ikilisi kartların altındaki ortak
 * bölümden ait olduğu talebin KENDİ kutusuna taşındı — switch açılınca o kartın
 * alt yarısında beliriyor. Bkz. TeknikTaleplerPanel'in kendi notu.
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  Container, Card, CardBody, Row, Col, Badge, Nav, NavItem, NavLink, Spinner, Alert, Button,
  Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input,
} from "reactstrap";
import {
  ArrowLeft, Clock, Sparkles, Users, Shield,
  Cog, PartyPopper, CookingPot, Waves, Flame, PawPrint, Scissors, Crosshair,
  Maximize2, Wrench, Armchair, CreditCard, FileText,
  Table2, TowelRack, Info,
} from "lucide-react";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import TarihGirdisi from "../../Components/Common/TarihGirdisi";
import DocumentPreviewModal from "../../Components/Common/DocumentPreviewModal";
// #722: the talep metni (HTML, PDFs, images) on the left of the request modal; the tick opens at its end like the login consent windows
import OnayMetniGovdesi, { DOSYA_DURUMU } from "../../Components/Common/OnayMetniGovdesi";
import { sonundaMi } from "../../Components/Common/OnayMetniPencereleri";
import { DIL } from "../../services/onayMetniService";
import CikisNoktasiPinner from "../../Components/Projects/CikisNoktasiPinner";
// #710: the stand's REAL outline for the pin (the wizard's pin was already on it, #676)
import { useStandKonturuYukle } from "../../Components/Projects/StandKonturSaglayici";
import { TEKNIK_ICONS } from "../../Components/Projects/StandPills";
import { planDosyasi } from "../../Components/Projects/kusbakisiYardimci";
import { getStandOverviewDetail } from "../../services/standOverviewService";
import { getProjectByStandId, getProjectFileUrl } from "../../services/projectService";
import {
  getTeknikTalepler, TEKNIK_TALEP_KATEGORILERI, declareTeknikTalepler, setTeknikExitPoint,
  // #696 (backend #695): a company's Teknik request is a draft until Gönder; createTeknikTalebi switches Elektrik on without a kW
  createTeknikTalebi, getTeknikGonderim, gonderTeknikTaslaklari,
  getHizmetTalepleri, HIZMET_TALEP_KATEGORILERI, createHizmetTalebi,
  getIsIzinleri, IS_IZNI_KATEGORILERI, createIsIzinTalebi,
  // #722 (backend #721): the text a company reads and ticks in the request modal, and the keys of the server's refusals about it
  getTalepMetni, TALEP_METNI_HATASI,
  TALEP_STATUS,
  getBorcDurumu, BORC_DURUMU_KATEGORILERI, HIZMET_BORC_META, BORC_DURUMU_STATUS,
} from "../../services/standTalepService";
// #456 (2026-10-17): the free-kW notice under the electricity input (backend #455: kwKontrol on the Elektrik row)
import KwUcretliUyari from "../../Components/Talep/KwUcretliUyari";
import { elektrikSatiri } from "../../Components/Talep/kwKontrol";
// #462 (2026-10-20): who entered a request (backend #454): the badge on every request card, and the notice before somebody overwrites what the other side entered
import TalepKaynagi from "../../Components/Talep/TalepKaynagi.jsx"; // .jsx written out: on a case-insensitive filesystem the bare name could also match a .js helper
import { baskaTarafGirdi } from "../../Components/Talep/talepKaynaklari";
// #510 (2026-10-20): an organizer opening a stand sees the exhibitor's page read-only (İzleme) or with the actions SAKA opened (Denetim)
import useStandGorunumu from "../../Components/Firma/useStandGorunumu";
import { KapaliEylemler } from "./OrganizatorPanelPage";
import { ORGANIZATOR_AYAR } from "../../services/portalService";
// #453 (2026-10-17): the history of the stand's requests (backend #452): who changed what, when, from which value to which
import TalepGecmisi from "../../Components/Talep/TalepGecmisi.jsx"; // .jsx written out: on a case-insensitive filesystem the bare name also matches talepGecmisi.js (the helper, no default export)
import { useTranslation } from "react-i18next";
import i18n, { currentLocaleTag, currentLanguageId } from "../../i18n";
// #500 (2026-10-19): the organizer's "Stands Above the Free kW" page opens a stand here with ?geri= / ?geriEtiket= so Back returns to it
import { geriHedefiOku } from "../../Components/Kisi/kisiBaglantilari";

// StandOverviewDetailPage.jsx'teki aynı isimli helper'ın dosya-yerel kopyası (bkz.
// dosya başı 2026-08-10 notu) — mock Stand Listesi/Talepler id'leri Mongo-tarzı hex
// string, gerçek backend id'leri sayısal `stand.stand_id`.
const isNumericStandId = (v) => /^\d+$/.test(String(v));

const TABS = [
  { key: "teknikTalepler", get label() { return i18n.t("portal:talepDetay.teknikTalepler"); } },
  { key: "hizmetTalepleri", get label() { return i18n.t("portal:talepDetay.hizmetTalepleri"); } },
  { key: "isIzinTalepleri", get label() { return i18n.t("portal:talepDetay.isIzinTalepleri"); } },
  { key: "ekipmanTalepleri", get label() { return i18n.t("portal:talepDetay.ekipmanTalepleri"); } },
  { key: "talepBorcDurumu", get label() { return i18n.t("portal:talepDetay.taleplerBorcDurumu"); } },
  // #453: the history of every request on this stand
  { key: "talepGecmisi", get label() { return i18n.t("portal:talepDetay.gecmis"); } },
];


const HIZMET_ICONS = {
  "24saatElektrik": Clock,
  temizlik: Sparkles,
  hostHostes: Users,
  guvenlik: Shield,
};

const IS_IZNI_ICONS = {
  makine: Cog,
  gosteri: PartyPopper,
  pisirme: CookingPot,
  sivi: Waves,
  sicak: Flame,
  hayvan: PawPrint,
  kesici: Scissors,
  silah: Crosshair,
};

const BORC_DURUMU_ICONS = {
  alan: Maximize2,
  teknik: Wrench,
  ekipman: Armchair,
  hizmet: Sparkles,
};

// Borç Durumu sekmesi artık Hizmet Borcu'nu da gösteriyor (2026-08-04, /revise-page)
// — standTalepService.js'teki `BORC_DURUMU_KATEGORILERI` kendisi kasıtlı olarak
// değişmedi (Talepler Listesi'ndeki kart rengini — FirmaTaleplerListPage.jsx'teki
// talepBorcRenk — ve FirmaAnasayfaListPage.jsx'teki "Talepler" widget'ının kutucuk
// rengini de besliyor, bu revizyonun kapsamı sadece bu sekme), bu yüzden sadece bu
// panelin render listesi `HIZMET_BORC_META` ile genişletiliyor. `getBorcDurumu`
// zaten `hizmet` kaydını dönüyordu (bkz. standTalepService.js'teki _mockBorcDurumu),
// sadece burada gösterilmiyordu — toplam borç (`totalBorc`, altta) kategoriye göre
// filtrelemediğinden hizmet borcunu zaten sayıyordu, sadece kutucuğu eksikti.
const BORC_DURUMU_TAB_KATEGORILERI = [...BORC_DURUMU_KATEGORILERI, HIZMET_BORC_META];

// Kategori renkleri standTalepService.js'te sabit hex olarak tanımlı (bu temada
// çalışma zamanı `--bs-*` CSS değişkenleri yok, bkz. o dosyadaki yorum).
const TALEP_GRAY = "#878a99";

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString(currentLocaleTag(), { day: "2-digit", month: "short", year: "numeric" });
}

// 2026-08-29: bu dosyadaki yerel InteractiveKrokiPin KOPYASI KALDIRILDI. Çıkış
// noktası artık tek başına bir krokiye değil, dekoratörün yüklediği Teknik Talep
// Planına BAKARAK işaretleniyor (plan solda, kroki sağda) ve plan yoksa pinleme
// kapalı — bkz. Components/Projects/CikisNoktasiPinner.jsx. Aynı bileşen Proje
// Beyanı sihirbazının "Çıkış Noktaları" adımında da kullanılıyor, iki yerde aynı
// kural geçerli olsun diye.

// Talep edilmemiş kategoriler gri gösterilir — talep edilmiş kategoriler her
// zaman kendi sabit rengini taşır. Hizmet Talepleri panelinin araç çubuğu
// (Teknik Talepler artık kendi switch tabanlı kartlarını kullanıyor, bkz.
// 2026-08-11 notu — bu bileşeni paylaşmıyor). `tabKey` Talepler Listesi'nden
// gelen ?kategori= odaklama hedefini (talep-anchor-<tabKey>-<key>) isimlendirmek
// için kullanılır — bkz. dosya sonundaki scroll/highlight effect'i. `onSelect`
// henüz talep edilmemiş kareleri tıklanabilir yapar — TalepOlusturModal'ı bu
// kategoriyle (İş Türü) önceden dolu açar.
function CategoryToolbar({ categories, icons, requestsByCategory, tabKey, onSelect }) {
  const { t } = useTranslation("portal");
  return (
    <div className="d-flex flex-wrap justify-content-around gap-3 py-2">
      {categories.map((cat) => {
        const Icon = icons[cat.key];
        const hasRequest = !!requestsByCategory[cat.key]?.hasRequest;
        const clickable = !hasRequest && !!onSelect;
        const interactiveProps = clickable
          ? {
              role: "button",
              tabIndex: 0,
              onClick: () => onSelect(cat),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSelect(cat);
                }
              },
            }
          : {};
        return (
          <div
            key={cat.key}
            id={`talep-anchor-${tabKey}-${cat.key}`}
            className="text-center"
            style={{ minWidth: 70, cursor: clickable ? "pointer" : undefined }}
            title={hasRequest ? cat.label : clickable ? t("talepDetay.talepOlustur", { label: cat.label }) : t("talepDetay.talepEdilmedi", { label: cat.label })}
            {...interactiveProps}
          >
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-3 mb-1"
              style={{ width: 44, height: 44, background: hasRequest ? cat.color : TALEP_GRAY, opacity: hasRequest ? 1 : 0.55 }}
            >
              <Icon size={20} color="#fff" />
            </div>
            <div className="small">{cat.label}</div>
          </div>
        );
      })}
    </div>
  );
}

// Hizmet Talepleri artık ortak talep formuyla oluşturuluyor (bkz. dosya başı
// 2026-07-23 notu) — kategoriye özgü eski schedule alanları (kişi sayısı/günler/
// saat) kaldırıldı, hepsi aynı Başlangıç–Bitiş + Yapılacak İş alanlarını gösterir.
// #722: "Text read: <date>" under a request card whose text was ticked (the row's metinOnayTarihi is 'YYYY-MM-DD HH:mm:ss')
function MetinOkunduNotu({ request }) {
  const { t } = useTranslation("portal");
  if (!request.metinOnayTarihi) return null;
  return (
    <div className="small text-muted mt-2" data-testid="metin-okundu">
      {t("talepDetay.metinOkundu", { tarih: fmtDate(String(request.metinOnayTarihi).replace(" ", "T")) })}
    </div>
  );
}

function TalepScheduleCard({ category, request }) {
  const Icon = HIZMET_ICONS[category.key];
  const statusInfo = TALEP_STATUS[request.status] ?? TALEP_STATUS[0];
  return (
    <Card className="h-100">
      <CardBody>
        <div className="text-center mb-3">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-3 mb-2"
            style={{ width: 44, height: 44, background: category.color }}
          >
            <Icon size={20} color="#fff" />
          </div>
          <div className="fw-semibold">{category.label}</div>
        </div>
        <div className="small text-muted mb-3 text-center">
          <div>{request.yapilacakIs || "—"}</div>
          <div>{fmtDate(request.startDate)} – {fmtDate(request.endDate)}</div>
        </div>
        <div className="text-center">
          <Badge color={statusInfo.color}>{statusInfo.label}</Badge>
          <div className="mt-2"><TalepKaynagi kaynak={request.kaynak} firmaAdi={request.kaynakFirmaAdi} /></div>
          <MetinOkunduNotu request={request} />
        </div>
      </CardBody>
    </Card>
  );
}

/**
 * Teknik Talepler (Elektrik/Su/Hava/İnternet) — 2026-08-11 revizyonu (/loop):
 * ikon-kare + modal akışı (talep etmek için kategoriye tıkla → Teknik Talep Planı
 * belgesini yükle → talep tamamlanır) kaldırıldı, yerine FirmaProjelerListPage.jsx'teki
 * Proje Beyanı popup'ıyla AYNI switch deseni geldi — her kategori kendi switch'iyle
 * doğrudan burada talep edilir/geri alınır, belge yükleme şartı yok (belge hâlâ
 * "Proje Dosyaları" sekmesinden yüklenebilir, bu sayfadan kaldırılan sadece ikinci
 * giriş noktasıydı, bkz. standTalepService.js'teki dosya başı notu). Elektrik'te
 * ayrıca switch'in yanında kW sayısal girişi var (ProjeBeyani'deki elektrikEnabled
 * ile birebir aynı desen).
 *
 * 2026-09-04 yerleşimi: dört kategori tek sırada dörde bölünmüş (md=3) şerit
 * yerine 2x2 — üstte iki, altta iki YARIM SAYFA kutusu. Çıkış noktaları da artık
 * kartların altındaki ayrı "Çıkış Noktaları" bölümünde DEĞİL, ait oldukları
 * talebin kendi kutusunun içinde: switch açılınca kartın alt yarısı ikiye bölünür,
 * solda gönderilen Teknik Talep Planı görseli, sağda pinlenecek kroki
 * (CikisNoktasiPinner'ın `embedded` yerleşimi — orada plan da kroki de sütun
 * genişliğine göre akışkandır, sabit px değil).
 *
 * Tek bir "Kaydet" düğmesi tüm paneli aynı anda gönderir: switch/kW durumu
 * declareTeknikTalepler (PUT /teknik, tam değiştirme — bkz. guide'ın "no body wipes
 * all four" uyarısı, bu yüzden dördü de her zaman birlikte gönderilir) ile CANLI
 * backend'e yazılır — bu uç zaten reconcile edilmiş, forceLive çalışır. Çıkış
 * noktaları ise KASITLI OLARAK mock kalır (Deniz, 2026-08-11): backend'de
 * `cikis-noktasi` ucu hiç yok (guide "Asked for but not built #1" — kroki sistemi
 * yeniden yazılana kadar ertelendi), setTeknikExitPoint bu yüzden forceLive almıyor
 * ve her zaman standTalepService.js'teki mock diziye yazıyor. Backend'in canlı GET'i
 * exitPoint'i her zaman null döndürdüğünden (mongo-stili mock id'ler dışında), `points`
 * state'i standId değişene kadar sunucudan gelen yenilemelerle ÜZERİNE YAZILMAZ —
 * aksi halde her kaydetmeden sonra pin ekrandan kaybolurdu. Yani işaretlenen nokta bu
 * sayfa oturumu boyunca görünür kalır ama sayfa yeniden yüklenince sıfırlanır —
 * bilinçli bir sınırlama, kroki yeniden yazımı gelene kadar.
 *
 * #696 (backend #695, 2026-11-02): Kaydet no longer sends a company's request to approval — the rows it switches on are DRAFTS (status 4, "Taslak"
 * badge) and a proje beyanı is not needed to start one. The Gönder button next to Kaydet (GET .../teknik/gonderim says whether it may be pressed) sends
 * every draft of the stand for approval; while it cannot, the list under the buttons says what is missing (the stand's Kuşbakışı, the Elektrik kW).
 * The exit-point pinner stays as it was and is not needed to send.
 */
// #510: `gorunum` is useStandGorunumu's answer (null = the exhibitor's page as it always was); #462: `benimFirmaId` is the viewer's company
function TeknikTaleplerPanel({ standId, numericStandId, refreshToken, forceLive = false, onSaved, showInfo, benimFirmaId = null, gorunum = null }) {
  const { t } = useTranslation("portal");
  // #710: the stand's drawn outline (GET /stands/talepler/{standId}/drawn-walls) for the exit-point pin: WITHOUT it the pin was 0-1 of the fixed L while the wizard's
  // was 0-1 of the real outline, two meanings in one stored field. null (not drawn, unreadable, a mock stand) keeps the L, which the pinner marks as a sample shape.
  const { kontur: standKonturu, yukleniyor: konturYukleniyor } = useStandKonturuYukle(numericStandId, { forceLive, etkin: forceLive && numericStandId != null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({});
  const [points, setPoints] = useState({});
  // #462: the four rows as the backend sent them (who entered each: kaynak, kaynakFirmaId, kaynakFirmaAdi)
  const [satirlar, setSatirlar] = useState({});
  // #510: an organizer adds / changes a request with TALEP_EKLE and withdraws one with TALEP_SIL (Denetim); at İzleme it does neither. The exhibitor does both.
  const ekleyebilir = !gorunum?.organizatorMu || gorunum.ekleyebilir;
  const silebilir = !gorunum?.organizatorMu || gorunum.silebilir;
  const duzenlenebilir = ekleyebilir || silebilir;
  // #456: the Elektrik row's free-kW check from the backend ({serbestKw, ..., odeme}); null = nothing to judge against
  const [kwKontrol, setKwKontrol] = useState(null);
  const [saving, setSaving] = useState(false);
  // #696: what the Gönder button needs ({ taslakSayisi, kusbakisiVar, eksikler, gonderilebilir }; null = not known, the button stays out),
  // the sending state, and the refusal of a send (kept inline: `error` would replace the whole panel)
  const [gonderim, setGonderim] = useState(null);
  const [sending, setSending] = useState(false);
  const [gonderHata, setGonderHata] = useState(null);
  // Teknik Talep Planı (standFileId 3 — mock ve canlı katalogda AYNI id, bkz.
  // FirmaStandDetailPage.jsx'teki DOC_GROUPS_MOCK/LIVE). Çıkış noktası bu çizime
  // bakılarak işaretlendiği için pin bu dosya olmadan açılmaz.
  const [planFile, setPlanFile] = useState(null);
  // standId değişince tüm state'in (points dahil) sıfırlanması gerekiyor — parent
  // bu bileşeni `key={standId}` ile render ediyor, bu yüzden standId değişimi ayrı
  // bir reset effect'i yerine doğrudan remount ile hallediliyor (bkz. çağrı yeri).
  const pointsSeededRef = useRef(false);

  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        // #696: the Gönder state is read with the rows; a failure only leaves the Gönder button out
        const [data, gonderimDurumu] = await Promise.all([
          getTeknikTalepler(standId, { forceLive }),
          getTeknikGonderim(standId, { forceLive }).catch(() => null),
        ]);
        if (ignore) return;
        setGonderim(gonderimDurumu ?? null);
        const nextForm = {};
        data.forEach((r) => {
          nextForm[r.categoryKey] = {
            enabled: !!r.hasRequest,
            kw: r.quantity?.value != null ? String(r.quantity.value) : "",
          };
        });
        setForm(nextForm);
        setSatirlar(Object.fromEntries(data.map((r) => [r.categoryKey, r])));
        setKwKontrol(elektrikSatiri(data)?.kwKontrol ?? null);
        // bkz. dosya başı 2026-08-11 notu — sadece standId değiştikten sonraki İLK
        // fetch'te seed edilir, Kaydet sonrası tetiklenen yeniden fetch'ler kullanıcının
        // az önce işaretlediği noktaları ezmesin diye.
        if (!pointsSeededRef.current) {
          // exitPoint KASITLI OLARAK ayrı, her zaman forceLive:false ile çekilir —
          // backend'in canlı GET'i (yukarıdaki `data`, forceLive:true'yken) bu alanı
          // hiç desteklemiyor, her zaman null döner (bkz. setTeknikExitPoint'in dosya
          // başı notu — çıkış noktası her zaman _mockTalepler'a yazılır). `data`'yı
          // burada kullanırsak, bu panel her sekme değişiminde/yeniden mount'ta
          // (activeTab değişince tamamen unmount oluyor, bkz. çağrı yeri) kendi az
          // önce kaydettiği pini kaybederdi — sadece Proje Bilgiler sekmesinde
          // görünürdü (aynı mock depoyu bu şekilde okuyan tek yer). İki sayfa da
          // artık aynı kaynağı okuyor.
          const pointSource = forceLive ? await getTeknikTalepler(standId, { forceLive: false }) : data;
          if (ignore) return;
          const seeded = {};
          pointSource.forEach((r) => { seeded[r.categoryKey] = r.exitPoint ?? null; });
          setPoints(seeded);
          pointsSeededRef.current = true;
        }
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [standId, refreshToken, forceLive]);

  // Teknik Talep Planı — projectService köprüsü üzerinden (buradaki `standId`
  // Talepler sayfasının kendi id'si, köprü SAYISAL stand id istiyor; bkz.
  // FirmaStandDetailPage.jsx'teki aynı getProjectByStandId kullanımı). İsteğe bağlı
  // bir zenginleştirme: başarısız olursa panel yine çalışır, sadece pin kapalı kalır.
  useEffect(() => {
    if (numericStandId == null) return undefined;
    let ignore = false;
    getProjectByStandId(numericStandId, { forceLive })
      .then((p) => {
        if (ignore) return;
        // #696 follow-up: the drawing is filed under Elektrik Planı and under 3-D Görseller > Kuşbakışı; the newest of either.
        setPlanFile(planDosyasi(p?.uploadedFiles));
      })
      .catch(() => { if (!ignore) setPlanFile(null); });
    return () => { ignore = true; };
  }, [numericStandId, forceLive, refreshToken]);

  if (loading) {
    return <div className="text-center py-4"><Spinner color="primary" size="sm" /></div>;
  }

  if (error) {
    return <Alert color="danger" className="mb-0">{error}</Alert>;
  }

  function updateEnabled(key, enabled) {
    setForm((f) => ({ ...f, [key]: { ...f[key], enabled } }));
  }

  function updateKw(key, kw) {
    setForm((f) => ({ ...f, [key]: { ...f[key], kw } }));
  }

  function updatePoint(key, point) {
    setPoints((p) => ({ ...p, [key]: point }));
  }

  // WAS (until #696): const elektrikMissingKw = form.elektrik?.enabled && (form.elektrik?.kw ?? "") === "";
  // #696: a company's Elektrik request is a DRAFT, and a draft may be saved without its kW (the kW is only needed to SEND it, the Gönder button
  // says so). A request already sent (not a draft) still needs it, and so does an organizer's (it writes straight to approval).
  const elektrikKwBos = form.elektrik?.enabled && (form.elektrik?.kw ?? "") === "";
  const kwsizTaslakOlur = !gorunum?.organizatorMu && !(satirlar.elektrik?.hasRequest && !satirlar.elektrik?.taslak);
  const elektrikMissingKw = elektrikKwBos && !kwsizTaslakOlur;
  const elektrikKwsizTaslak = elektrikKwBos && kwsizTaslakOlur;
  // Switch'i açık kategoriler — çıkış noktası yalnızca bunlar için sorulur.
  const talepEdilenler = TEKNIK_TALEP_KATEGORILERI.filter((c) => form[c.key]?.enabled);

  // #696: Gönder sends what is SAVED, so a form that differs from the saved rows has to be saved first
  const degisti = TEKNIK_TALEP_KATEGORILERI.some((c) => {
    const f = form[c.key] ?? { enabled: false, kw: "" };
    const s = satirlar[c.key];
    if (f.enabled !== !!s?.hasRequest) return true;
    return c.type === "quantity" && f.enabled && f.kw !== (s?.quantity?.value != null ? String(s.quantity.value) : "");
  });
  const gonderimGoster = ekleyebilir && gonderim != null && gonderim.taslakSayisi > 0;

  async function handleSave() {
    if (elektrikMissingKw) return;
    setSaving(true);
    setError(null);
    setGonderHata(null);
    try {
      const entries = {};
      TEKNIK_TALEP_KATEGORILERI.forEach((c) => {
        const f = form[c.key] ?? { enabled: false, kw: "" };
        entries[c.key] = c.type === "quantity" ? (f.enabled ? f.kw : "") : f.enabled;
      });
      const rows = await declareTeknikTalepler(standId, entries, { forceLive });
      // PUT /teknik reads an empty kW as "no electricity request": the kW-less draft is switched on through the per-category write, which keeps the quantity
      if (elektrikKwsizTaslak) await createTeknikTalebi(standId, "elektrik", { forceLive });
      await Promise.all(
        TEKNIK_TALEP_KATEGORILERI
          .filter((c) => form[c.key]?.enabled && points[c.key])
          .map((c) => setTeknikExitPoint(standId, c.key, points[c.key]))
      );
      // WAS (until #696): showInfo?.("Teknik talepler kaydedildi.");
      showInfo?.(elektrikKwsizTaslak || (Array.isArray(rows) && rows.some((r) => r.taslak)) ? t("talepDetay.teknikTaslakKaydedildi") : t("talepDetay.teknikKaydedildi"));
      onSaved?.();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  // #696: Gönder = POST .../teknik/gonder, every draft of the stand at once. A 409 (the Kuşbakışı or the Elektrik kW missing) writes nothing and
  // comes back with its eksikler, which replace the list under the buttons.
  async function handleGonder() {
    setSending(true);
    setGonderHata(null);
    try {
      await gonderTeknikTaslaklari(standId, { forceLive });
      showInfo?.(t("talepDetay.taslaklarGonderildi"));
      onSaved?.();
    } catch (e) {
      setGonderHata(e.message);
      if (e.eksikler?.length) setGonderim((g) => (g ? { ...g, eksikler: e.eksikler, gonderilebilir: false } : g));
    } finally {
      setSending(false);
    }
  }

  return (
    <div>
      {talepEdilenler.length > 0 && (
        <div className="text-muted small mb-3">
          {t("talepDetay.talepEttiginizHerKalemIcin")}
          <span className="fw-semibold">{t("talepDetay.teknikTalepPlaninaBakarak")}</span>{" "}{t("talepDetay.oTalebinKendiKutusundakiKrokide")}
        </div>
      )}
      <Row className="g-3">
        {TEKNIK_TALEP_KATEGORILERI.map((cat) => {
          const Icon = TEKNIK_ICONS[cat.key];
          const f = form[cat.key] ?? { enabled: false, kw: "" };
          const satir = satirlar[cat.key];
          // #510: a saved request is withdrawn only with the right to withdraw; a new one is switched on only with the right to add
          const kilitli = satir?.hasRequest ? !silebilir : !ekleyebilir;
          return (
            <Col lg={6} key={cat.key} id={`talep-anchor-teknikTalepler-${cat.key}`}>
              <Card className="h-100">
                <CardBody>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center gap-2">
                      <div
                        className="d-inline-flex align-items-center justify-content-center rounded-3"
                        style={{ width: 32, height: 32, background: f.enabled ? cat.color : TALEP_GRAY }}
                      >
                        <Icon size={16} color="#fff" />
                      </div>
                      <span className="fw-semibold small">{cat.label}</span>
                      {/* #696: saved but not sent for approval yet (status 4); gone once Gönder has sent it */}
                      {satir?.taslak && (
                        <Badge color="secondary" title={t("talepDetay.taslakAciklama")} data-testid={`teknik-taslak-${cat.key}`}>
                          {t("talepDetay.taslak")}
                        </Badge>
                      )}
                    </div>
                    <FormGroup switch className="mb-0">
                      <Input
                        type="switch" role="switch"
                        checked={f.enabled} disabled={kilitli}
                        onChange={(e) => updateEnabled(cat.key, e.target.checked)}
                      />
                    </FormGroup>
                  </div>

                  {/* #462: who entered this request; and, when somebody else did (the other side, or SAKA), that changing it here keeps the earlier values in the history */}
                  {satir?.hasRequest && (
                    <div className="mb-2" data-testid={`teknik-kaynak-${cat.key}`}>
                      <TalepKaynagi kaynak={satir.kaynak} firmaAdi={satir.kaynakFirmaAdi} />
                      {duzenlenebilir && baskaTarafGirdi(satir, benimFirmaId) && (
                        <div className="small text-muted mt-1" data-testid={`teknik-baska-taraf-${cat.key}`}>
                          {t("talepDetay.baskaTarafGirdi", { kaynak: t(`organizator.talepFiltre.kaynaklar.${satir.kaynak}`) })}
                        </div>
                      )}
                    </div>
                  )}

                  {cat.type === "quantity" && (
                    <>
                      <div className="small text-muted mb-1">{t("talepDetay.standinizinElektrikGucuKW")}</div>
                      <Input
                        type="number" min="0" step="1" bsSize="sm" className="mb-1"
                        placeholder={t("talepDetay.kW")} disabled={!f.enabled || !ekleyebilir}
                        value={f.kw} onChange={(e) => updateKw(cat.key, e.target.value)}
                        invalid={elektrikMissingKw}
                      />
                      {elektrikMissingKw && (
                        <div className="text-danger small mb-1">{t("talepDetay.elektrikIcinKWGirin")}</div>
                      )}
                      {/* #696: no kW yet is fine for a draft; it is needed to send */}
                      {elektrikKwsizTaslak && ekleyebilir && (
                        <div className="text-muted small mb-1" data-testid="teknik-kwsiz-taslak">{t("talepDetay.kwsizTaslak")}</div>
                      )}
                      {/* #456: the free kW of this stand, and as soon as the typed kW is above it a warning that the excess is charged (the request is saved
                          anyway) and, when the organizer registered one, a Pay button (new tab, with its host) */}
                      <KwUcretliUyari kwKontrol={kwKontrol} istenenKw={f.kw} etkin={f.enabled} />
                    </>
                  )}

                  {/* Switch açıksa çıkış noktası ikilisi kartın alt yarısına düşer:
                      solda gönderilen Teknik Talep Planı, sağda pinlenecek kroki
                      (bkz. CikisNoktasiPinner'ın `embedded` yerleşimi). */}
                  {/* #710: not while the outline is still being asked for: a pin put on the L for a moment would mean something else once the real outline arrives */}
                  {f.enabled && ekleyebilir && konturYukleniyor && (
                    <div className="text-center py-3"><Spinner size="sm" color="secondary" /></div>
                  )}
                  {f.enabled && ekleyebilir && !konturYukleniyor && (
                    <CikisNoktasiPinner
                      embedded
                      category={cat}
                      planFile={planFile}
                      planUrl={planFile?.storedFileName ? getProjectFileUrl(planFile.storedFileName) : null}
                      value={points[cat.key] ?? null}
                      onChange={(p) => updatePoint(cat.key, p)}
                      kontur={standKonturu}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          );
        })}
      </Row>

      {/* WAS (until #510): the Kaydet row was always drawn; an organizer at İzleme (nothing to save) no longer gets it */}
      {duzenlenebilir && (
        <div className="mt-3">
          {/* #696: the drafts waiting to be sent, and, when Gönder is not possible yet, what is missing (the Kuşbakışı, the Elektrik kW) */}
          {gonderimGoster && (
            <div className="small mb-2" data-testid="teknik-gonderim">
              <div className="text-muted">{t("talepDetay.taslakBilgisi", { count: gonderim.taslakSayisi })}</div>
              {gonderim.eksikler?.length > 0 && (
                <Alert color="warning" className="py-2 mt-2 mb-0" data-testid="teknik-eksikler">
                  <div className="fw-semibold">{t("talepDetay.gonderEksikBaslik")}</div>
                  <ul className="mb-0 ps-3">
                    {gonderim.eksikler.map((kod) => (
                      <li key={kod} data-testid={`teknik-eksik-${kod}`}>{t(`talepDetay.gonderEksik.${kod}`, { defaultValue: kod })}</li>
                    ))}
                  </ul>
                </Alert>
              )}
              {gonderim.gonderilebilir && degisti && <div className="text-muted mt-1">{t("talepDetay.gonderOnceKaydedin")}</div>}
              {gonderHata && <Alert color="danger" className="py-2 mt-2 mb-0" data-testid="teknik-gonder-hata">{gonderHata}</Alert>}
            </div>
          )}
          <div className="d-flex justify-content-end gap-2">
            <Button color="danger" size="sm" disabled={saving || sending || elektrikMissingKw} onClick={handleSave}>
              {saving && <Spinner size="sm" className="me-1" />}{" "}{t("common:kaydet")}
            </Button>
            {gonderimGoster && (
              <Button
                color="success" size="sm" data-testid="teknik-gonder"
                disabled={saving || sending || degisti || !gonderim.gonderilebilir} onClick={handleGonder}
              >
                {sending && <Spinner size="sm" className="me-1" />}{" "}{t("talepDetay.gonder")}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function HizmetTalepleriPanel({ standId, refreshToken, onSelectCategory, forceLive = false }) {
  const { t } = useTranslation("portal");
  const [requests, setRequests] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const data = await getHizmetTalepleri(standId, { forceLive });
        if (!ignore) setRequests(data);
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [standId, refreshToken, forceLive]);

  if (loading) {
    return <div className="text-center py-4"><Spinner color="primary" size="sm" /></div>;
  }

  if (error) {
    return <Alert color="danger" className="mb-0">{error}</Alert>;
  }

  const requestsByCategory = {};
  (requests || []).forEach((r) => { requestsByCategory[r.categoryKey] = r; });

  const cards = HIZMET_TALEP_KATEGORILERI.filter((c) => requestsByCategory[c.key]?.hasRequest);
  const isEmpty = cards.length === 0;

  return (
    <div>
      <Card className="mb-3">
        <CardBody>
          <CategoryToolbar
            categories={HIZMET_TALEP_KATEGORILERI} icons={HIZMET_ICONS} requestsByCategory={requestsByCategory}
            tabKey="hizmetTalepleri" onSelect={onSelectCategory}
          />
          {onSelectCategory && <div className="text-center text-muted small mt-1">{t("talepDetay.yeniTalepOlusturmakIcinGri")}</div>}
        </CardBody>
      </Card>

      {isEmpty ? (
        <Alert color="secondary" className="mb-0">{t("talepDetay.henuzTalepOlusturulmadi")}</Alert>
      ) : (
        <Row className="g-3">
          {cards.map((c) => (
            <Col md={4} sm={6} key={c.key}>
              <TalepScheduleCard category={c} request={requestsByCategory[c.key]} />
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
}

// İş izni araç çubuğu — genel kategorilerin aksine renk kategoriye değil sadece
// "talep var mı yok mu"na bağlıdır (teal=var, gri=yok), tüm kategoriler için aynı ton.
// `onSelect` verildiğinde henüz talep edilmemiş kareler tıklanabilir olur —
// CategoryToolbar'daki aynı desen, bkz. dosya başı 2026-07-23 notu.
function IsIzinToolbar({ requestsByCategory, onSelect }) {
  const { t } = useTranslation("portal");
  return (
    <div className="d-flex flex-wrap justify-content-around gap-3 py-2">
      {IS_IZNI_KATEGORILERI.map((cat) => {
        const Icon = IS_IZNI_ICONS[cat.key];
        const hasRequest = !!requestsByCategory[cat.key]?.hasRequest;
        const clickable = !hasRequest && !!onSelect;
        const interactiveProps = clickable
          ? {
              role: "button",
              tabIndex: 0,
              onClick: () => onSelect(cat),
              onKeyDown: (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onSelect(cat);
                }
              },
            }
          : {};
        return (
          <div
            key={cat.key}
            id={`talep-anchor-isIzinTalepleri-${cat.key}`}
            className="text-center"
            style={{ minWidth: 70, cursor: clickable ? "pointer" : undefined }}
            title={hasRequest ? cat.label : clickable ? t("talepDetay.talepOlustur", { label: cat.label }) : t("talepDetay.talepEdilmedi", { label: cat.label })}
            {...interactiveProps}
          >
            <div
              className="d-inline-flex align-items-center justify-content-center rounded-3 mb-1"
              style={{ width: 44, height: 44, background: hasRequest ? "#178f8f" : TALEP_GRAY, opacity: hasRequest ? 1 : 0.55 }}
            >
              <Icon size={20} color="#fff" />
            </div>
            <div className="small">{cat.label}</div>
          </div>
        );
      })}
    </div>
  );
}

// İş izni kartı — ikon karesinin rengi kategoriye değil talebin onay durumuna bağlıdır
// (teal=Onaylı, turuncu=Bekliyor, kırmızı=Reddedildi), rozetle aynı bilgiyi taşır.
// Başlık artık ortak talep formundaki `yapilacakIs` alanından geliyor (eskiden
// ayrı bir serbest metin `title` alanıydı, bkz. standTalepService.js'teki 2026-07-23 notu).
function IsIzinCard({ category, request }) {
  const Icon = IS_IZNI_ICONS[category.key];
  const statusInfo = TALEP_STATUS[request.status] ?? TALEP_STATUS[0];
  return (
    <Card className="h-100">
      <CardBody className="text-center">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-3 mb-2"
          style={{ width: 56, height: 56, background: statusInfo.hex }}
        >
          <Icon size={24} color="#fff" />
        </div>
        <div className="mb-1">{request.yapilacakIs || category.label}</div>
        <div className="small text-muted mb-2">{fmtDate(request.startDate)} – {fmtDate(request.endDate)}</div>
        <Badge color={statusInfo.color}>{statusInfo.label}</Badge>
        <div className="mt-2"><TalepKaynagi kaynak={request.kaynak} firmaAdi={request.kaynakFirmaAdi} /></div>
        <MetinOkunduNotu request={request} />
      </CardBody>
    </Card>
  );
}

function IsIzinTalepleriPanel({ standId, refreshToken, onSelectCategory, forceLive = false }) {
  const { t } = useTranslation("portal");
  const [requests, setRequests] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const data = await getIsIzinleri(standId, { forceLive });
        if (!ignore) setRequests(data);
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [standId, refreshToken, forceLive]);

  if (loading) {
    return <div className="text-center py-4"><Spinner color="primary" size="sm" /></div>;
  }

  if (error) {
    return <Alert color="danger" className="mb-0">{error}</Alert>;
  }

  const requestsByCategory = {};
  (requests || []).forEach((r) => { requestsByCategory[r.categoryKey] = r; });

  const cards = IS_IZNI_KATEGORILERI.filter((c) => requestsByCategory[c.key]?.hasRequest);
  const isEmpty = cards.length === 0;

  return (
    <div>
      <Card className="mb-3">
        <CardBody>
          <IsIzinToolbar requestsByCategory={requestsByCategory} onSelect={onSelectCategory} />
          {onSelectCategory && <div className="text-center text-muted small mt-1">{t("talepDetay.yeniTalepOlusturmakIcinGri")}</div>}
        </CardBody>
      </Card>

      {isEmpty ? (
        <Alert color="secondary" className="mb-0">{t("talepDetay.henuzIsIzniTalebiOlusturulmadi")}</Alert>
      ) : (
        <Row className="g-3">
          {cards.map((c) => (
            <Col md={3} sm={6} key={c.key}>
              <IsIzinCard category={c} request={requestsByCategory[c.key]} />
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
}

// Ekipman Talepleri (2026-08-04, ikinci /revise-page): eski tek kalemlik gerçek
// talep izleme/oluşturma akışı (hasRequest/durum rozeti/"+" oluştur düğmesi,
// getEkipmanTalebi/createEkipmanTalebi) kaldırıldı — sekme artık sadece "ne tür
// ekipman talep edebilirsiniz" fikrini veren sabit/statik örnek ürünleri (Masa/
// Sandalye/Askılık), eski kartla AYNI Card+CardBody görünümünde ama HER BİRİ kendi
// ayrı kartında gösteriyor, altındaki not bunların örnek/temsili olduğunu ve bir
// satış/satın alma akışı planlanmadığını belirtiyor. `getEkipmanTalebi`/
// `createEkipmanTalebi` standTalepService.js'te silinmedi — FirmaTaleplerListPage.jsx'teki
// liste kartının Ekipman ikon-karesi hâlâ o veriyi okuyor, sadece bu sekme artık
// çağırmıyor. O kart hâlâ `?tab=ekipmanTalepleri` ile buraya yönlendiriyor, anchor
// id bu yüzden korundu — artık tek bir kalemi değil, tüm sekmeyi hedefliyor.
const EKIPMAN_ORNEK_URUNLER = [
  { key: "masa", get label() { return i18n.t("portal:talepDetay.masa"); }, icon: Table2 },
  { key: "sandalye", get label() { return i18n.t("portal:talepDetay.sandalye"); }, icon: Armchair },
  { key: "askilik", get label() { return i18n.t("portal:talepDetay.askilik"); }, icon: TowelRack },
];

function EkipmanOrnekUrunKart({ urun }) {
  return (
    <Card className="h-100">
      <CardBody className="text-center">
        <div
          className="d-inline-flex align-items-center justify-content-center rounded-3 mb-2"
          style={{ width: 56, height: 56, background: "#878a99" }}
        >
          <urun.icon size={24} color="#fff" />
        </div>
        <div className="fw-semibold">{urun.label}</div>
      </CardBody>
    </Card>
  );
}

function EkipmanTalepleriPanel() {
  const { t } = useTranslation("portal");
  return (
    <div id="talep-anchor-ekipmanTalepleri-ekipman">
      <Row className="g-3">
        {EKIPMAN_ORNEK_URUNLER.map((urun) => (
          <Col md={4} sm={6} key={urun.key}>
            <EkipmanOrnekUrunKart urun={urun} />
          </Col>
        ))}
      </Row>
      <div className="d-flex align-items-start gap-2 text-muted small mt-3">
        <Info size={14} className="flex-shrink-0 mt-1" />
        <span>{t("talepDetay.buUrunlerOrnekTemsiliUrunlerdir")}</span>
      </div>
    </div>
  );
}

// Borç kategori karesi/pili rengi kategoriye değil kalemin durumuna bağlıdır
// (teal=Ödendi, kırmızı=Bekliyor tutarlı, gri=bu kalemden borç hiç oluşmadı) —
// İş İzni kartlarındaki aynı "durum rengi" yaklaşımı, bkz. IsIzinCard yorumu.
function BorcDurumuPanel({ standId, onPayAll, forceLive = false }) {
  const { t } = useTranslation("portal");
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const data = await getBorcDurumu(standId, { forceLive });
        if (!ignore) setItems(data);
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [standId, forceLive]);

  if (loading) {
    return <div className="text-center py-4"><Spinner color="primary" size="sm" /></div>;
  }

  if (error) {
    return <Alert color="danger" className="mb-0">{error}</Alert>;
  }

  const byCategory = {};
  (items || []).forEach((i) => { byCategory[i.categoryKey] = i; });
  const totalBorc = (items || [])
    .filter((i) => i.status === "bekliyor")
    .reduce((sum, i) => sum + (i.amount || 0), 0);

  return (
    <Card>
      <CardBody>
        <div className="fw-semibold mb-3">{t("talepDetay.borcDurumu")}</div>
        <div className="d-flex justify-content-center mb-4">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle"
            style={{ width: 80, height: 80, background: "#f06548" }}
          >
            <CreditCard size={36} color="#fff" />
          </div>
        </div>
        <Row>
          {BORC_DURUMU_TAB_KATEGORILERI.map((cat) => {
            const item = byCategory[cat.key];
            const status = item?.status ?? "yok";
            const info = BORC_DURUMU_STATUS[status] ?? BORC_DURUMU_STATUS.yok;
            const Icon = BORC_DURUMU_ICONS[cat.key];
            return (
              <Col md={3} className="text-center mb-3" key={cat.key}>
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-3 mb-2"
                  style={{ width: 44, height: 44, background: info.hex }}
                >
                  <Icon size={20} color="#fff" />
                </div>
                <div className="small mb-2">{cat.label}</div>
                <div className="rounded-3 py-2 text-white fw-semibold" style={{ background: info.hex }}>
                  {status === "bekliyor" ? `${item.amount} ₺` : info.label}
                </div>
              </Col>
            );
          })}
        </Row>
        <div className="d-flex justify-content-between align-items-center mt-2">
          <div className="text-muted small">{t("talepDetay.toplamBorc", { totalBorc })}</div>
          {/* WAS (until #510): always drawn; an organizer's view passes no onPayAll and gets no pay button */}
          {onPayAll && (
            <Button color="primary" size="sm" disabled={totalBorc <= 0} onClick={onPayAll}>
              {t("talepDetay.tumBorclariOde")}
            </Button>
          )}
        </div>
      </CardBody>
    </Card>
  );
}

const EMPTY_TALEP_FORM = {
  startDate: "", endDate: "",
  sergilenecekUrun: "", yapilacakIs: "", operator: "",
  ekipmanMalzemeListesi: "", isOzeti: "", riskler: "",
};

const TALEP_CREATE_FN = {
  hizmet: createHizmetTalebi,
  isIzni: createIsIzinTalebi,
};

/**
 * Hizmet/İş İzin/Ekipman Talepleri'nin ortak talep oluşturma popup'ı (bkz. dosya
 * başı 2026-07-23 notu) — Teknik Talepler bu modalı kullanmaz. `target`:
 * { kind: 'hizmet'|'isIzni'|'ekipman', standId, category: {key, label} } — null
 * iken kapalı. Reset-on-open, parent'ta `key={target ? ... : "closed"}` remount'uyla
 * yapılır (bkz. CreateProjectModal, FirmaProjelerListPage.jsx'teki aynı desen).
 */
function TalepOlusturModal({ target, onClose, onCreated }) {
  const { t } = useTranslation("portal");
  const [form, setForm] = useState(EMPTY_TALEP_FORM);
  const [files, setFiles] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [previewFileName, setPreviewFileName] = useState(null);

  // #722 (backend #721): İş İzni and Hizmet categories may carry a text the company reads and ticks before sending. "yukleniyor" until
  // the GET answers; "yok" (204, or a kind without texts) = the modal as before; "hazir" = text on the left; "hata" = Gönder stays off.
  const metinIster = target?.kind === "isIzni" || target?.kind === "hizmet";
  const [metin, setMetin] = useState(null);
  const [metinDurum, setMetinDurum] = useState(metinIster ? "yukleniyor" : "yok");
  const [metinHatasi, setMetinHatasi] = useState(null);
  const [metinDeneme, setMetinDeneme] = useState(0);
  const [okundu, setOkundu] = useState(false);
  const [sonunda, setSonunda] = useState(false);
  const [dosyaDurum, setDosyaDurum] = useState(null);
  const metinKutusu = useRef(null);

  const isOpen = Boolean(target);
  const metinKind = target?.kind;
  const metinStandId = target?.standId;
  const metinKategori = target?.category?.key;
  const metinForceLive = target?.forceLive;

  // KURAL: fetch Effect içindeki async fonksiyonda (react-hooks/set-state-in-effect). `t` bağımlılık değil (her render yeni olabilir).
  useEffect(() => {
    if (metinKind !== "isIzni" && metinKind !== "hizmet") return undefined;
    let iptal = false;
    async function yukle() {
      setMetinDurum("yukleniyor");
      setMetinHatasi(null);
      setMetin(null);
      setOkundu(false);
      setSonunda(false);
      setDosyaDurum(null);
      try {
        const m = await getTalepMetni(metinStandId, metinKind, metinKategori, { forceLive: metinForceLive });
        if (iptal) return;
        setMetin(m);
        setMetinDurum(m ? "hazir" : "yok");
      } catch (e) {
        if (iptal) return;
        setMetinHatasi(e.message);
        setMetinDurum("hata");
      }
    }
    yukle();
    return () => { iptal = true; };
  }, [metinKind, metinStandId, metinKategori, metinForceLive, metinDeneme]);

  // Kutu takıldığı an bir kez ölçülür: kaydırılacak kadar uzun değilse onay kutusu hemen açılır (OnayPenceresi.kutuyuTak ile aynı kural).
  const metinKutusunuTak = useCallback((el) => {
    metinKutusu.current = el;
    if (el) setTimeout(() => setSonunda(sonundaMi(el)), 0);
  }, []);

  const dosyaBekliyor = (metin?.dosyalar || []).length > 0
    && dosyaDurum !== DOSYA_DURUMU.HAZIR && dosyaDurum !== DOSYA_DURUMU.HATA;
  const dosyaHatasi = dosyaDurum === DOSYA_DURUMU.HATA;

  // Dosyalar inince kutu uzar (ilk ölçüm kısa kutuda yapılmış olabilir): son yükseklikte yeniden ölç.
  useEffect(() => {
    if (metinDurum !== "hazir" || dosyaBekliyor) return undefined;
    const id = setTimeout(() => setSonunda(sonundaMi(metinKutusu.current)), 0);
    return () => clearTimeout(id);
  }, [metinDurum, dosyaBekliyor]);

  function update(field, value) {
    setForm((f) => ({ ...f, [field]: value }));
  }

  const onayAcik = sonunda && !dosyaBekliyor && !dosyaHatasi;
  const zorunluMetin = metinDurum === "hazir" && metin?.isRequired !== false;
  const metinTamam = metinDurum === "yok" || (metinDurum === "hazir" && (!zorunluMetin || okundu));
  const canSubmit = form.startDate !== "" && form.endDate !== "" && metinTamam;

  async function handleSubmit() {
    if (!canSubmit || !target) return;
    setSubmitting(true);
    setError(null);
    try {
      const payload = { ...form, personnelDocs: files.map((f) => ({ name: f.name })) };
      // Sent only when ticked: the version the company read, so the request remembers it (and the server refuses a stale one).
      if (zorunluMetin && okundu) payload.metinSurumId = metin.surumId;
      const createFn = TALEP_CREATE_FN[target.kind];
      const opts = { forceLive: target.forceLive };
      if (target.kind === "ekipman") {
        await createFn(target.standId, payload, opts);
      } else {
        await createFn(target.standId, target.category.key, payload, opts);
      }
      onCreated();
    } catch (e) {
      setError(e.message);
      // The text was published again while the modal was open: show the server's message, drop the tick and load the new text.
      if (e.messageKey === TALEP_METNI_HATASI.DEGISTI) setMetinDeneme((n) => n + 1);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <>
    <Modal isOpen={isOpen} toggle={submitting ? undefined : onClose} centered size={metinDurum === "hazir" ? "xl" : "lg"}>
      <ModalHeader toggle={submitting ? undefined : onClose}>
        {t("talepDetay.talepOlustur2")}{target?.category ? ` — ${target.category.label}` : ""}
      </ModalHeader>
      <ModalBody>
        {error && <Alert color="danger">{error}</Alert>}
        {metinDurum === "yukleniyor" && (
          <div className="small text-muted mb-3" data-testid="talep-metni-yukleniyor"><Spinner size="sm" className="me-2" />{t("talepDetay.metinYukleniyor")}</div>
        )}
        {metinDurum === "hata" && (
          <Alert color="warning" className="small d-flex flex-wrap align-items-center gap-2" data-testid="talep-metni-hata">
            <span className="flex-grow-1">{t("talepDetay.metinYuklenemedi", { hata: metinHatasi })}</span>
            <Button color="light" size="sm" onClick={() => setMetinDeneme((n) => n + 1)}>{t("talepDetay.metinTekrarDene")}</Button>
          </Alert>
        )}

        <Row className="g-3">
          {metinDurum === "hazir" && (
            <Col lg={5} className="order-first" data-testid="talep-metni">
              <h6 className="mb-2">{metin.baslik}</h6>
              <div ref={metinKutusunuTak} onScroll={() => { if (sonundaMi(metinKutusu.current)) setSonunda(true); }}
                className="talep-metni-kaydirma" data-testid="talep-metni-kaydirma">
                {currentLanguageId() === DIL.EN && metin.languageId === DIL.TR && (
                  <p className="small text-muted fst-italic">{t("fuarKurallari.ingilizcesiYok")}</p>
                )}
                <OnayMetniGovdesi icerik={metin.icerik} dosyalar={metin.dosyalar} onDurum={setDosyaDurum} />
              </div>
              {zorunluMetin && (
                <>
                  <div className="form-check mt-3 mb-1">
                    <Input id="talep-metni-onay" type="checkbox" className="form-check-input" checked={okundu} disabled={!onayAcik || submitting}
                      onChange={(e) => setOkundu(e.target.checked)} data-testid="talep-metni-onay" />
                    <Label for="talep-metni-onay" className="form-check-label">{t("talepDetay.metinOkudumOnayliyorum")}</Label>
                  </div>
                  {!onayAcik && !okundu && <div className="small text-muted">{t("talepDetay.metinSonunaKadarKaydirin")}</div>}
                </>
              )}
            </Col>
          )}
          <Col lg={metinDurum === "hazir" ? 7 : 12}>
            <FormGroup className="mb-3">
              <Label size="sm">{t("talepDetay.isTuru")}</Label>
              <Input bsSize="sm" value={target?.category?.label ?? ""} disabled />
            </FormGroup>

            <Row className="g-3 mb-3">
              <Col md={6}>
                <FormGroup className="mb-0">
                  <Label size="sm">{t("talepDetay.baslangic")}{" "}<span className="text-danger">*</span></Label>
                  <TarihGirdisi value={form.startDate} onChange={(v) => update("startDate", v)} />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup className="mb-0">
                  <Label size="sm">{t("talepDetay.bitis")}{" "}<span className="text-danger">*</span></Label>
                  <TarihGirdisi value={form.endDate} onChange={(v) => update("endDate", v)} />
                </FormGroup>
              </Col>
            </Row>

            <Row className="g-3 mb-3">
              <Col md={4}>
                <FormGroup className="mb-0">
                  <Label size="sm">{t("talepDetay.sergilenecekUrun")}</Label>
                  <Input bsSize="sm" value={form.sergilenecekUrun} onChange={(e) => update("sergilenecekUrun", e.target.value)} />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="mb-0">
                  <Label size="sm">{t("talepDetay.yapilacakIs")}</Label>
                  <Input bsSize="sm" value={form.yapilacakIs} onChange={(e) => update("yapilacakIs", e.target.value)} />
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="mb-0">
                  <Label size="sm">{t("talepDetay.operator")}</Label>
                  <Input bsSize="sm" value={form.operator} onChange={(e) => update("operator", e.target.value)} />
                </FormGroup>
              </Col>
            </Row>

            <FormGroup className="mb-3">
              <Label size="sm">
                {t("talepDetay.gorevliPersonelIleIlgiliBelgelerin")}
                <span className="text-muted fw-normal">
                  {t("talepDetay.orneginMakinePeriyodikKontrolBelgesi")}
                </span>
              </Label>
              <Input type="file" bsSize="sm" multiple onChange={(e) => setFiles(Array.from(e.target.files || []))} />
              {files.length > 0 && (
                <div className="d-flex flex-wrap gap-2 mt-2">
                  {files.map((f, i) => (
                    <Badge
                      key={`${f.name}-${i}`}
                      color="light"
                      className="text-dark border d-inline-flex align-items-center gap-1 fw-normal"
                      style={{ cursor: "pointer" }}
                      title={t("talepDetay.belgeyiOnizlemekIcinTiklayin")}
                      onClick={() => setPreviewFileName(f.name)}
                    >
                      <FileText size={11} /> {f.name}
                    </Badge>
                  ))}
                </div>
              )}
            </FormGroup>

            <FormGroup className="mb-3">
              <Label size="sm">{t("talepDetay.kullanilacakEkipmanVeMalzemeListesi")}</Label>
              <Input
                type="textarea" rows={2} bsSize="sm"
                value={form.ekipmanMalzemeListesi} onChange={(e) => update("ekipmanMalzemeListesi", e.target.value)}
              />
            </FormGroup>

            <FormGroup className="mb-3">
              <Label size="sm">{t("talepDetay.yapilacakIsinKisaOzeti")}</Label>
              <Input type="textarea" rows={2} bsSize="sm" value={form.isOzeti} onChange={(e) => update("isOzeti", e.target.value)} />
            </FormGroup>

            <FormGroup className="mb-0">
              <Label size="sm">
                {t("talepDetay.risklerVeOnlemler")}
                <span className="text-muted fw-normal">
                  {t("talepDetay.isinYapilmasiSirasindaOngorulenOlasi")}
                </span>
              </Label>
              <Input type="textarea" rows={2} bsSize="sm" value={form.riskler} onChange={(e) => update("riskler", e.target.value)} />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" outline onClick={onClose} disabled={submitting}>{t("talepDetay.vazgec")}</Button>
        <Button color="danger" onClick={handleSubmit} disabled={!canSubmit || submitting}>
          {submitting && <Spinner size="sm" className="me-1" />}
          {t("talepDetay.talebiGonder")}
        </Button>
      </ModalFooter>
    </Modal>
    <DocumentPreviewModal
      isOpen={!!previewFileName}
      toggle={() => setPreviewFileName(null)}
      fileName={previewFileName}
    />
    </>
  );
}

export default function FirmaTalepStandDetailPage() {
  const { t: tx } = useTranslation("portal");
  const { standId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const focusKategori = searchParams.get("kategori");
  // #500: where Back goes; null (opened from the Talepler list) = the list, as before
  const geriHedefi = geriHedefiOku(searchParams);
  // WAS (until #510): const geriGit = () => navigate(geriHedefi?.from ?? "/Firma/Talepler");
  // #510: an organizer's Back, with nothing in ?geri=, goes to the organizer's own request list
  const geriGit = () => navigate(geriHedefi?.from ?? (gorunum.organizatorMu ? "/Firma/Organizator/Talepler" : "/Firma/Talepler"));
  const geriEtiketi = geriHedefi?.fromLabel ?? tx("talepDetay.listeyeDon");
  // bkz. dosya başı 2026-08-10 notu — mock Talepler Listesi'nden gelen Mongo-tarzı
  // id'ler ile fuar 298/299'un gerçek sayısal standId'lerini aynı sayfada ayırt eder.
  const isLiveStandId = isNumericStandId(standId);

  const [stand, setStand] = useState(null);
  // #510: is this the organizer's view of the stand (the active set is the organizer's and the company has no role on this stand)? and at which tier
  const gorunum = useStandGorunumu(stand);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // Talepler Listesi'ndeki bir kutucuktan ?tab=<TABS anahtarı> ile gelinmişse
  // ilgili sekmede açılır (bkz. FirmaTaleplerListPage.jsx'teki StandTalepTiles/goTo).
  const [activeTab, setActiveTab] = useState(() => {
    const requested = searchParams.get("tab");
    return TABS.some((t) => t.key === requested) ? requested : "teknikTalepler";
  });
  const [infoMsg, setInfoMsg] = useState(null);
  // Hizmet/İş İzin/Ekipman ortak talep oluşturma popup'ının hedefi — null iken
  // kapalı (bkz. TalepOlusturModal). refreshToken, oluşturma sonrası ilgili
  // panelin yeniden fetch etmesini tetikler (bkz. panellerin useEffect dep'i).
  const [talepModalTarget, setTalepModalTarget] = useState(null);
  const [talepRefreshToken, setTalepRefreshToken] = useState(0);

  useEffect(() => { document.title = i18n.t("portal:talepDetay.standTalepleriFds"); }, []);

  // İlgili sekmenin kategori araç çubuğu satırı kendi async fetch'i bitene kadar
  // DOM'da yok (bkz. Teknik/Hizmet/İşİzin/Ekipman panellerinin kendi loading
  // state'i) — bu yüzden tek seferlik effect yerine kısa bir polling kullanılır.
  // React state'e dokunulmuyor, sadece DOM üzerinde çalışıyor (bkz. aynı gerekçe
  // FirmaPersonelDetailPage.jsx'teki scroll/highlight effect'inde).
  useEffect(() => {
    if (loading || !stand || !focusKategori) return;
    const anchorId = `talep-anchor-${activeTab}-${focusKategori}`;
    let attempts = 0;
    let highlightTimer = null;
    const poll = setInterval(() => {
      attempts += 1;
      const el = document.getElementById(anchorId);
      if (el) {
        clearInterval(poll);
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.classList.add("border", "border-primary");
        highlightTimer = setTimeout(() => el.classList.remove("border", "border-primary"), 2500);
      } else if (attempts > 20) {
        clearInterval(poll);
      }
    }, 100);
    return () => {
      clearInterval(poll);
      if (highlightTimer) clearTimeout(highlightTimer);
    };
  }, [loading, stand, activeTab, focusKategori]);

  function showInfo(msg) {
    setInfoMsg(msg);
    setTimeout(() => setInfoMsg(null), 3500);
  }

  function openTalepModal(kind, category) {
    setTalepModalTarget({ kind, standId: stand.id, category, forceLive: isLiveStandId });
  }

  function handleTalepCreated() {
    setTalepModalTarget(null);
    setTalepRefreshToken((t) => t + 1);
    showInfo(tx("talepDetay.talepOlusturulduOnayBekleniyor"));
  }

  useEffect(() => {
    let ignore = false;

    async function run() {
      setLoading(true);
      setError(null);
      try {
        const detail = await getStandOverviewDetail(standId, { forceLive: isLiveStandId });
        if (!ignore) setStand(detail);
      } catch (e) {
        if (!ignore) setError(e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }

    run();
    return () => { ignore = true; };
  }, [standId, isLiveStandId]);

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid className="text-center py-5"><Spinner color="primary" /></Container>
      </div>
    );
  }

  if (error && !stand) {
    return (
      <div className="page-content">
        <Container fluid>
          <Alert color="danger">{error}</Alert>
          <Button color="secondary" outline size="sm" onClick={geriGit}>
            <ArrowLeft size={14} className="me-1" />{" "}{geriEtiketi}
          </Button>
        </Container>
      </div>
    );
  }

  if (!stand) return null;

  const salonNumber = stand.salonName?.match(/\d+/)?.[0] ?? stand.salonName;
  const izinVar = stand.requiredCount > 0 && stand.approvedCount === stand.requiredCount;

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("talepDetay.talepler", { standName: stand.standName })} pageTitle={tx("talepDetay.firma")} />

        {error && <Alert color="danger">{error}</Alert>}
        {infoMsg && <Alert color="info">{infoMsg}</Alert>}
        {/* #510: an organizer at İzleme is told once that this page only shows; at Denetim the actions SAKA closed are listed with their reason (#418) */}
        {gorunum.organizatorMu && (gorunum.salt
          ? <Alert color="light" className="small border py-2" data-testid="stand-izleme">{tx("organizator.izlemeBilgisi")}</Alert>
          : <KapaliEylemler kodlar={[ORGANIZATOR_AYAR.TALEP_EKLE, ORGANIZATOR_AYAR.TALEP_SIL]} izin={gorunum.izin} kapaliNedeni={gorunum.kapaliNedeni} />)}

        <Button color="secondary" outline size="sm" className="mb-3" onClick={geriGit}>
          <ArrowLeft size={14} className="me-1" />{" "}{geriEtiketi}
        </Button>

        <Card className="mb-4 overflow-hidden">
          <div className="bg-light">
            <div className="p-4">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="bg-white rounded-3 text-center px-3 py-2 shadow-sm" style={{ minWidth: 72 }}>
                  <div className="fw-bold fs-5 text-dark lh-1">{salonNumber}</div>
                  <div className="fw-semibold small text-info lh-1 mt-1">{stand.standName}</div>
                </div>
                <div>
                  <h4 className="text-dark mb-0">{stand.firmaName}</h4>
                  <div className="text-muted small">{stand.dekoratorFirmaName || "—"}</div>
                  <Badge color={izinVar ? "success" : "danger"} className="mt-1">
                    {izinVar ? tx("talepDetay.insaatIzniVar") : tx("talepDetay.insaatIzniYok")}
                  </Badge>
                </div>
              </div>
            </div>
            <Nav pills className="px-4 gap-2 border-0" style={{ position: "relative" }}>
              {TABS.map((t) => (
                <NavItem key={t.key}>
                  <NavLink
                    active={activeTab === t.key}
                    className={activeTab === t.key ? "bg-danger text-white" : "bg-white text-dark"}
                    style={{ cursor: "pointer", borderRadius: "6px 6px 0 0" }}
                    onClick={() => setActiveTab(t.key)}
                  >
                    {t.label}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
          </div>
        </Card>

        {activeTab === "teknikTalepler" && (
          <TeknikTaleplerPanel
            key={stand.id} standId={stand.id} numericStandId={stand.standId}
            refreshToken={talepRefreshToken}
            forceLive={isLiveStandId}
            onSaved={() => setTalepRefreshToken((t) => t + 1)}
            showInfo={showInfo}
            benimFirmaId={gorunum.benimFirmaId} gorunum={gorunum}
          />
        )}

        {activeTab === "hizmetTalepleri" && (
          <HizmetTalepleriPanel
            standId={stand.id} refreshToken={talepRefreshToken}
            onSelectCategory={gorunum.ekleyebilir ? (cat) => openTalepModal("hizmet", cat) : undefined} forceLive={isLiveStandId}
          />
        )}

        {activeTab === "isIzinTalepleri" && (
          <IsIzinTalepleriPanel
            standId={stand.id} refreshToken={talepRefreshToken}
            onSelectCategory={gorunum.ekleyebilir ? (cat) => openTalepModal("isIzni", cat) : undefined} forceLive={isLiveStandId}
          />
        )}

        {activeTab === "ekipmanTalepleri" && <EkipmanTalepleriPanel />}

        {activeTab === "talepBorcDurumu" && (
          <BorcDurumuPanel
            standId={stand.id} forceLive={isLiveStandId}
            onPayAll={gorunum.organizatorMu ? undefined : () => showInfo(tx("talepDetay.odemeAkisiYakindaEklenecek"))}
          />
        )}

        {/* #453: who changed what on this stand's requests; read again after a save made on another tab */}
        {activeTab === "talepGecmisi" && (
          <Card><CardBody><TalepGecmisi standId={stand.standId} yenileJetonu={talepRefreshToken} /></CardBody></Card>
        )}

        <TalepOlusturModal
          key={talepModalTarget ? `${talepModalTarget.kind}-${talepModalTarget.category?.key}` : "closed"}
          target={talepModalTarget}
          onClose={() => setTalepModalTarget(null)}
          onCreated={handleTalepCreated}
        />
      </Container>
    </div>
  );
}
